module.exports = __webpack_public_path__ + "static/media/restraunt.af26365b.jpg";